import * as yup from 'yup';

const validationSchema = yup.object({
  streetAddress: yup.string().required('Required'),
  locality: yup.string().required('Required'),
  postalCode: yup.string().required('Required'),
  region: yup.string().required('Required'),
  country: yup.string().required('Required'),
});

export default validationSchema;
